import React, { useEffect } from 'react';
import Modal from 'bootstrap/js/dist/modal.js';

const FittingInstructionMovie = ({ component, index }) => {
  if (!component) return null;

  const modalId = `fitAssistantVideoModal-${index}`;

  const onOpen = () => {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    const iframe = modal.querySelector('iframe');
    if (iframe) {
      iframe.src =
        component?.AssetURL?.split('?')[0] + '?autoplay=1&mute=1&controls=1&rel=0&enablejsapi=1&playsinline=0';
    }
    Modal.getOrCreateInstance(modal).show();
  };

  useEffect(() => {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    const handleHide = () => {
      const iframe = modal.querySelector('iframe');
      if (iframe) iframe.src = '';
    };
    modal.addEventListener('hidden.bs.modal', handleHide);
    return () => modal.removeEventListener('hidden.bs.modal', handleHide);
  }, [modalId]);

  const cloudflareId = component.CloudflareMovieId || '';
  const hasAssetUrl = !!component.AssetURL;
  const isDirectWithAsset = component.IsDirectVideo && hasAssetUrl;
  const hasCloudflareId = cloudflareId !== '';
  const isYoutubeWithAsset = component.IsYoutube && hasAssetUrl;
  const directUrl = isDirectWithAsset ? component.AssetURL : '';
  const posterImage =
    component.HighResThumbnailUrl || component.ThumbnailUrl?.replace('/default.jpg', '/maxresdefault.jpg') || '';

  return (
    <>
      {(isDirectWithAsset || hasCloudflareId) && !isYoutubeWithAsset ? (
        <div className="instruction-item m-3 fittingInstructionMovie">
          <thule-video-player
            cloudflare-id={cloudflareId}
            youtube-url=""
            direct-url={directUrl}
            poster-image={posterImage}
            compact-player="true"
          />
          {component.VideoTitle && <span className="heading6 m-2">{component.VideoTitle}</span>}
        </div>
      ) : isYoutubeWithAsset ? (
        <>
          <div className="instruction-item m-3 fittingInstructionMovie">
            <div className="video position-relative">
              <img src={component.ThumbnailUrl.replace('/default.jpg', '/maxresdefault.jpg')} />
              <button
                onClick={onOpen}
                className="btn ytPlayBtn instruction-yt-button"
                id={`ytPlayBtn-instruction-${index}`}
              >
                <span className="sr-only">Play video</span>
                <div className="btn ytPlayIcon">
                  <i className="le-icon-play"></i>
                </div>
              </button>
            </div>
            <span className="heading6 m-2">{component.VideoTitle}</span>
          </div>
          <div className="modal fade instruction-video-modal" id={modalId} tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <iframe allowFullScreen frameBorder="0" loading="lazy"></iframe>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default FittingInstructionMovie;
